<template>
  <div class="ListPanel">
    <HeaderSection 
      :title="title"
      :closeLinkTo="{ name: 'home'}">
      <p>
        Klik op een gemeente om een lijst met verhalen van die gemeente te bekijken, 
        of klik op de 'zoom' knop om op de gemeente in te zoomen.
      </p>
    </HeaderSection>

    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      type="gemeente"
      readmore="oplichten" />

    <GroeiTip />
  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';
import GroeiTip from '@/views/partials/GroeiTip';

export default {
  name: 'ListGemeenten',
  components: {
    List,
    HeaderSection,
    GroeiTip
  },
  data() {
    return {
      title: 'Gemeenten',
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z'
        }
      ]
    }
  },
  computed: {
    items() {
      let items = this.$store.getters.getGemeentenList;

      items.forEach((item) => {
        item.to = { name: 'gemeente-beknopt', params: { slug: item.slug } };
        return item;
      });

      return items;
    }
  }
}
</script>

<style lang="scss">

  .ListPanel {
    height: 100%;
    display: flex;
    flex-direction: column;

    .List {
      width: 100%;
      flex-grow: 1;
    }
  }

</style>
